import { Link } from 'react-router-dom';

export default function LocalDelivery() {
  return (
    <section className="py-20 px-8 bg-[#181818] border-t border-b border-[#333333]">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-map-pin-line text-4xl text-white"></i>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-3xl md:text-4xl font-black text-white">
              Kalamazoo Local? We Deliver.
            </h3>
            <p className="text-base text-gray-400">
              No transportation? No problem. Free local delivery on orders over $50.
            </p>
          </div>
          
          <Link 
            to="/local-delivery" 
            className="text-sm font-medium text-white hover:underline flex items-center gap-2 whitespace-nowrap"
          >
            LEARN MORE <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}